<div [formGroup]="form">
  <section class="ia-form-section">
    <h3>Contact details</h3>
    <p class="ia-form-help">Required fields are marked <span aria-hidden="true">*</span>.</p>
    <ng-container *ngTemplateOutlet="fields; context: { $implicit: contactFields }"></ng-container>
  </section>
  <section class="ia-form-section">
    <h3>Shipping address</h3>
    <ng-container *ngTemplateOutlet="fields; context: { $implicit: addressFields }"></ng-container>
    <div class="ia-form-grid mt-3">
      <div class="ia-field">
        <label [for]="idPrefix + '-countryCode'">Country or region <span aria-hidden="true">*</span></label>
        <select class="form-control" formControlName="countryCode" [id]="idPrefix + '-countryCode'"
          autocomplete="shipping country" aria-required="true" [attr.aria-invalid]="invalid('countryCode')"
          [attr.aria-describedby]="invalid('countryCode') ? idPrefix + '-countryCode-error' : null">
          <option *ngFor="let country of countries.list" [value]="country">{{ 'COUNTRIES.' + country + '.NAME' | translate }}</option>
        </select>
        <p *ngIf="invalid('countryCode')" [id]="idPrefix + '-countryCode-error'" class="ia-field-error">Choose a country or region.</p>
      </div>
      <div class="ia-field">
        <label [for]="idPrefix + '-state'">State or province</label>
        <select class="form-control" formControlName="state" [id]="idPrefix + '-state'"
          autocomplete="shipping address-level1" *ngIf="countries.getStates(form.value.countryCode).length">
          <option *ngFor="let state of countries.getStates(form.value.countryCode)" [value]="state">
            {{ 'COUNTRIES.' + form.value.countryCode + '.STATES.' + state | translate }}
          </option>
        </select>
        <input type="text" class="form-control" formControlName="state" [id]="idPrefix + '-state'"
          autocomplete="shipping address-level1" *ngIf="countries.getStates(form.value.countryCode).length === 0">
      </div>
    </div>
  </section>
  <ng-template #fields let-list>
    <div class="ia-form-grid" [formGroup]="form">
      <div *ngFor="let field of list" class="ia-field">
        <label [for]="idPrefix + '-' + field.control">{{ field.label }} <span *ngIf="field.required" aria-hidden="true">*</span></label>
        <input class="form-control" [type]="field.type" [formControlName]="field.control" [id]="idPrefix + '-' + field.control"
          [autocomplete]="field.autocomplete" [attr.aria-required]="field.required" [attr.aria-invalid]="invalid(field.control)"
          [attr.aria-describedby]="invalid(field.control) ? idPrefix + '-' + field.control + '-error' : null">
        <p *ngIf="invalid(field.control)" [id]="idPrefix + '-' + field.control + '-error'" class="ia-field-error">
          {{ field.control === 'email' ? 'Enter a valid email address.' : field.label + ' is required.' }}
        </p>
      </div>
    </div>
  </ng-template>
</div>
